import React from 'react';
import { styled } from '@compiled/react';
import InfoIcon from '@atlaskit/icon/glyph/info';
import { colors, gridSize } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { FormattedMessage } from '@atlassian/jira-intl';
import { messages } from './messages';
import { ResetButton } from './reset-button';
import { SaveButton } from './save-button';

export const Footer = () => (
	<>
		<InfoWrapper>
			<ColoredIcon>
				<InfoIcon label="" />
			</ColoredIcon>
			<FormattedMessage {...messages.changesApplyToAllPlans} />
		</InfoWrapper>
		<SaveButton />
		<ResetButton />
	</>
);

// using display flex due to bug in ak-icon not baselining properly
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const InfoWrapper = styled.div({
	display: 'flex',
	alignItems: 'center',
	marginTop: token('space.300', '24px'),
	marginBottom: token('space.300', '24px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ColoredIcon = styled.span({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: token('color.icon.accent.purple', colors.P200),
	paddingLeft: token('space.025', '2px'),
	paddingRight: token('space.025', '2px'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	height: gridSize() * 3,
});
